import React from 'react'

// Components
import TextInput from 'components/input/TextInput'

// Data
import {
    options,
    levels
} from 'utils/constants/data';

function Schooling({
    values,
    errors,
    touched,
    setFieldValue,
    handleChange,
    handleBlur,
}) {

    return (
        <div className='bg-white rounded-lg mx-4 px-6 py-4 md:px-10 md:py-8 space-y-4 sm:space-y-6'>
            <p className='uppercase text-xl sm:text-2xl mb-2 md:mb-4 font-bold'>Schooling</p>
            <hr className='h-1 border-none text-[#333] bg-[#333]' />
            <p className='uppercase text-lg sm:text-xl xl:text-2xl mb-2 md:mb-4 font-bold'>14. What is your highest completed school level?</p>
            <p className='text-sm xl:text-base'>If you are currently enrolled in secondary education, the <i>Highest School Level Completed</i> refers to the highest school level you have actually completed and not the level you are currently undertaking. For example, if you are currently in Year 10 the <i>Highest School Level Completed</i> is Year 9.</p>
            <div className='flex flex-col space-y-4'>
                {levels.map((level, i) => {
                    return (
                        <div className='flex flex-row items-center space-x-3'>
                            <div>
                                <input
                                    checked={values.school_level === level.title}
                                    id={`school-level-option-radio-btn-${i}`}
                                    name={`school-level-option-${i}`}
                                    type="radio"
                                    onChange={() => setFieldValue(`school_level`, level.title)}
                                    value={values.school_level}
                                    className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
                                />
                            </div>
                            <p className='text-base xl:text-lg' key={i}>{level.title}</p>
                        </div>
                    )
                })}
            </div>
            {(errors?.school_level && touched?.school_level) && errors.school_level && (
                <p className='text-xs sm:text-sm xl:text-base text-red-500'>{errors.school_level}</p>
            )}
            {values.school_level === "02 – Never Attended School" && (
                <p className='text-sm xl:text-base font-semibold'>If you never completed any primary or secondary level education – Go To  Question 16.</p>
            )}
            {values.school_level && values.school_level !== "" && values.school_level !== "02 – Never Attended School" && (
                <div className='space-y-4 sm:space-y-6'>
                    <p className='uppercase text-lg sm:text-xl xl:text-2xl mb-2 md:mb-4 font-bold'>15. Are you still enrolled in secondary or senior secondary education?</p>
                    <div className='flex flex-col space-y-2'>
                        {options.map((option, i) => {
                            return (
                                <div className='flex flex-row items-center space-x-3'>
                                    <div>
                                        <input
                                            checked={values.is_still_in_secondary_edu === option.value}
                                            id={`still-secondary-radio-btn-${i}`}
                                            name={`still-secondary-${i}`}
                                            type="radio"
                                            onChange={() => setFieldValue(`is_still_in_secondary_edu`, option.value)}
                                            value={values.is_still_in_secondary_edu}
                                            className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
                                        />
                                    </div>
                                    <p className='text-base xl:text-lg' key={i}>{option.title}</p>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )}
        </div>
    )
}

export default Schooling